import { format } from 'date-fns'
import bgLocale from 'date-fns/locale/bg'
import csLocale from 'date-fns/locale/cs'
import deLocale from 'date-fns/locale/de'
import enLocale from 'date-fns/locale/en'
import msLocale from 'date-fns/locale/en'
import esLocale from 'date-fns/locale/es'
import frLocale from 'date-fns/locale/fr'
import hrLocale from 'date-fns/locale/hr'
import huLocale from 'date-fns/locale/hu'
import itLocale from 'date-fns/locale/it'
import plLocale from 'date-fns/locale/pl'
import ptLocale from 'date-fns/locale/pt'
import ruLocale from 'date-fns/locale/ru'
import ukLocale from 'date-fns/locale/ru'
import svLocale from 'date-fns/locale/sv'
import trLocale from 'date-fns/locale/tr'
import elLocale from 'date-fns/locale/el'
import filLocale from 'date-fns/locale/fil'
import jaLocale from 'date-fns/locale/ja'
import koLocale from 'date-fns/locale/ko'
import thLocale from 'date-fns/locale/th'
import inLocale from 'date-fns/locale/id'
import roLocale from 'date-fns/locale/ro'
import React from 'react'
import { WithTranslation } from 'react-i18next'
import { CountryCode } from '../../../i18n/countryCodes'

interface ILocaleJSON {
  [key: string]: ILocaleJSON | string
}

const languageDetector: Map<CountryCode, ILocaleJSON> = new Map()
languageDetector.set('bg', bgLocale as ILocaleJSON)
languageDetector.set('cz', csLocale as ILocaleJSON)
languageDetector.set('de', deLocale as ILocaleJSON)
languageDetector.set('en', enLocale as ILocaleJSON)
languageDetector.set('es', esLocale as ILocaleJSON)
languageDetector.set('fr', frLocale as ILocaleJSON)
languageDetector.set('hr', hrLocale as ILocaleJSON)
languageDetector.set('hu', huLocale as ILocaleJSON)
languageDetector.set('it', itLocale as ILocaleJSON)
languageDetector.set('pl', plLocale as ILocaleJSON)
languageDetector.set('pl_PL', plLocale as ILocaleJSON)
languageDetector.set('pt', ptLocale as ILocaleJSON)
languageDetector.set('pt_BR', ptLocale as ILocaleJSON)
languageDetector.set('ru', ruLocale as ILocaleJSON)
languageDetector.set('se', svLocale as ILocaleJSON)
languageDetector.set('tr', trLocale as ILocaleJSON)
languageDetector.set('el', elLocale as ILocaleJSON)
languageDetector.set('fil', filLocale as ILocaleJSON)
languageDetector.set('ja', jaLocale as ILocaleJSON)
languageDetector.set('ko', koLocale as ILocaleJSON)
languageDetector.set('ms', msLocale as ILocaleJSON)
languageDetector.set('th', thLocale as ILocaleJSON)
languageDetector.set('in', inLocale as ILocaleJSON)
languageDetector.set('ro', roLocale as ILocaleJSON)
languageDetector.set('uk', ukLocale as ILocaleJSON)

function formatDate(date: Date, dateFormat: string, lang: CountryCode): string {
  return format(date, dateFormat, {
    locale: languageDetector.get(lang),
  })
}

function DayFormat({
                     date,
                     dateFormat,
                     i18n,
                     className,
                     style = {},
                   }: IDayFormat & WithTranslation) {
  return (
    <div style={style} className={className}>
      {formatDate(date, dateFormat, i18n.language as CountryCode)}
    </div>
  )
}

export default DayFormat

export interface IDayFormat {
  date: Date
  dateFormat: string
  className?: string
  style?: any
}

export { languageDetector, formatDate }
